'use strict'

import Vue from 'vue'

const HeaderIcon = require('./components/' + DEVICE + '/HeaderIcon').default

/**
 * アラート・モーダルUI Class
 */
class HeaderIconUI {
    /**
     * vueインスタンス
     * @type {vue}
     * @private
     */
    v

    /**
     * コンストラクタ
     * @constructor
     */
    startUI() {
        if (!this.v) {
            if (document.querySelector('#headerIcon')) {
                let vObj = new Vue({
                    el: '#headerIcon',
                    template: '<HeaderIcon ref="headericon"/>',
                    components: { HeaderIcon }
                })
                this.v = vObj.$refs['headericon']
            }
        }
    }
}

const headericon = new HeaderIconUI()
export default headericon
